


































































































import { ApiClient } from "@/api/client";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Content } from "@/interfaces/content";
import { mapState } from "vuex";
import CloudflarePlayer from "@/components/CloudflarePlayer.vue";
import ContentList from "@/components/ContentList.vue";
import PurchaseButton from "@/components/PurchaseButton.vue";

@Component({
  computed: {
    ...mapState(["contents", "showChargeModal"])
  },
  components: {
    PurchaseButton,
    CloudflarePlayer,
    ContentList
  }
})
export default class ContentDetails extends Vue {
  // Mapped from vuex
  contents: any;

  // Other variables
  api: ApiClient = new ApiClient();
  content: Content = {} as Content;
  showFullDescription: boolean = false;

  get date(): string {
    try {
      const d = Date.parse(this.content.created_at);
      const ye = new Intl.DateTimeFormat("de", { year: "numeric" }).format(d);
      const mo = new Intl.DateTimeFormat("de", { month: "long" }).format(d);
      const da = new Intl.DateTimeFormat("de", { day: "2-digit" }).format(d);

      return `${da}. ${mo} ${ye}`;
    } catch (e) {
      return "";
    }
  }

  get duration(): string {
    const duration = (this.content ? this.content.video_duration : 0) || 0;

    return (
      Math.floor(duration / 60) +
      ":" +
      ("0" + Math.floor(duration % 60)).slice(-2)
    );
  }

  get shortDescription(): string {
    try {
      const limit = 320;
      const description = this.content.text || "";
      if (description.length > limit) {
        return `${description.substring(0, limit)} ...`;
      }
      return description;
    } catch (e) {
      return "";
    }
  }

  @Watch("$route")
  onRouteChange() {
    this.$Progress.start();
    this.$Progress.set(40);

    this.api
      .getContent(this.$route.params.id)
      .then((content: Content) => {
        this.$Progress.set(70);
        this.$store.commit("setContent", content);
        this.content = this.contents[this.$route.params.id];
        this.showFullDescription = false;
        this.$Progress.finish();
      })
      .catch((error: any) => {
        this.$Progress.fail();
        this.$router.push("/");
      });
  }

  mounted() {
    this.content = this.contents[this.$route.params.id];
    this.$Progress.finish();
  }
}
